import InlineCalendly from './InlineCalendly'

export default function Schedule() {
  return (
    <div>
      <InlineCalendly />
    </div>
  )
}
